import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import SearchableSelect from "@/features/shared/components/SearchableSelect/SearchableSelect";
import { IoIosAddCircle } from "react-icons/io";
import { TiDeleteOutline } from "react-icons/ti";
import InputIcon from "@/features/shared/components/InputIcon/InputIcon";
import useMissions from "@/features/mission/hooks/useMissions";
import ToggleSection from "@/features/shared/components/ToggleSection/ToggleSection";
const MissionsSection = ({ onSelect, initialValue }) => {
    const { missions } = useMissions(undefined, undefined, true);
    const [taskMissions, setTaskMissions] = useState(initialValue || []);
    const [selectedMissions, setSelectedMissions] = useState([]);
    const [customMission, setCustomMission] = useState("");
    const missionOptions = missions.map((m) => ({
        value: m.id ?? 0,
        label: m.label ?? "",
    }));
    const handleAddMissionFromSelect = useCallback((missionOption) => {
        if (!selectedMissions.some((c) => c.value === missionOption.value)) {
            const newMission = { id: missionOption.value, label: missionOption.label, amount: 0 };
            setSelectedMissions([...selectedMissions, missionOption]);
            if (!taskMissions.some((c) => c.id === missionOption.value)) {
                setTaskMissions([...taskMissions, newMission]);
            }
        }
    }, [selectedMissions]);
    const handleAddCustomMission = useCallback(() => {
        const trimmed = customMission.trim();
        if (trimmed !== "") {
            const exists = selectedMissions.some((c) => c.label.toLowerCase() === trimmed.toLowerCase());
            if (!exists) {
                const newMission = { id: 0, label: trimmed, amount: 0 };
                setSelectedMissions([...selectedMissions, { value: 0, label: trimmed }]);
                setTaskMissions([...taskMissions, newMission]);
                setCustomMission("");
            }
        }
    }, [customMission, selectedMissions]);
    const handleRemoveMission = useCallback((missionToRemove) => {
        setSelectedMissions((prev) => prev.filter((c) => c.value !== missionToRemove.id));
        setTaskMissions((prev) => prev.filter((c) => c.id !== missionToRemove.id));
    }, []);
    const handleCustomMissionChange = useCallback((e) => {
        setCustomMission(e.target.value);
    }, []);
    useEffect(() => {
        onSelect(taskMissions);
    }, [taskMissions, onSelect]);
    return (_jsxs(_Fragment, { children: [_jsx(ToggleSection, { title: "Ajouter une mission", initiallyOpen: false, children: _jsxs("div", { className: "grid grid-cols-1 md:grid-cols-2 gap-6", children: [_jsx("div", { children: _jsx(SearchableSelect, { label: "Missions", options: missionOptions, selectedItems: selectedMissions, onAdd: handleAddMissionFromSelect, onRemove: handleRemoveMission }) }), _jsx("div", { className: "mt-4", children: _jsx(InputIcon, { label: "Autres Missions", value: customMission, onChange: handleCustomMissionChange, onIconClick: handleAddCustomMission, icon: _jsx(IoIosAddCircle, { className: "w-6 h-6" }) }) })] }) }), taskMissions.length > 0 && (_jsxs("div", { className: "mt-4", children: [_jsx("h3", { className: "text-sm font-medium text-gray-700 mb-2", children: "Missions s\u00E9lectionn\u00E9es :" }), _jsx("ul", { className: "pl-5 list-disc", children: taskMissions.map((mission) => (_jsxs("li", { className: "flex items-center space-x-2", children: [_jsx("button", { type: "button", onClick: () => handleRemoveMission(mission), title: "Supprimer", children: _jsx(TiDeleteOutline, { className: "w-5 h-5 text-red-500" }) }), _jsx("span", { children: mission.label })] }, mission.id))) })] }))] }));
};
export default MissionsSection;
